import Util from './libs/util';

const util = new Util();

export default class effectManager {
    constructor(){
        this.$svgTarget = $(".js__tsc-svg-write,.js__svg-write");

        this.splitStatus = {
            delay :[]
        }

    }
    show($target,type){

        switch (type){
            case "set":
                if(Useragnt.mobile){
                    TweenMax.set($target,{y:110+"%",opacity:0});
                }else{
                    TweenMax.set($target,{y:110+"%",scale:1.2,opacity:0});
                }
                break;
            case "show":
                if(Useragnt.mobile){
                    TweenMax.staggerTo($target,0.6, {
                        y:0+"%",
                        opacity:1,
                        // scale:1,
                        ease: "Power2.easeOut",
                    },0.1);
                }else{
                    TweenMax.staggerTo($target,0.6, {
                        y:0+"%",
                        // opacity:1,
                        scale:1,
                        ease: "Power2.easeOut",
                    },0.1);
                    TweenMax.staggerTo($target,0.4, {
                        opacity:1,
                        ease: "Power2.easeOut",
                    },0.1);
                }

                break;
            case "out":
                if(Useragnt.mobile){
                    TweenMax.staggerTo($target,0.3, {
                        y:200+"%",
                        opacity:0,
                        ease: "Power2.easeIn",
                    },0.05);
                }else{
                    TweenMax.staggerTo($target,0.3, {
                        y:200+"%",
                        ease: "Power2.easeIn",
                    },0.05);
                    TweenMax.staggerTo($target,0.2, {
                        opacity:0,
                        ease: "Power2.easeIn",
                    },0.1);
                }
                break;
        }

    }
    cover($target,type){
        let _speed = Useragnt.mobile ? 0.5 : 0.6;

        switch (type){
            case "set":
                TweenMax.set($target,{ x:-101+"%"});
                break;
            case "show":


                for(let i=0; i<$target.length; i++){

                    TweenMax.fromTo($target.eq(i),_speed,
                        {
                            x : -101+"%"
                        },
                        {
                            x:0+"%",
                            // z:0,
                            delay : 0.1 * util.random(0,6),
                            ease: "Power2.easeInOut",
                            // ease: "SlowMo.ease.config(0.5, 0.7, false)",
                        },0.1);

                }


                break;
            case "out":

                for(let i=0; i<$target.length; i++){

                    TweenMax.to($target.eq(i),0.4, {
                        x:101+"%",
                        // z:0,
                        delay : 0.1 * util.random(0,6),
                        // ease: "Power2.easeInOut",
                        ease: "Power2.easeIn",
                        // ease: "SlowMo.ease.config(0.5, 0.7, false)",
                    },0.1);

                }
                break;
        }
    }
    line($target,type){

        switch (type){
            case "set":
                TweenMax.set($target,{x:101+"%"});
                break;
            case "show":
                TweenMax.fromTo($target,0.6,{
                    x : -101+"%",
                },{
                    x : 0+"%",
                    // ease: Expo.easeOut,
                    ease: Power2.easeOut,
                })
                break;
            case "out":
                TweenMax.to($target,0.6,{
                    x : 101+"%",
                    ease: Expo.easeOut,
                })
                break;
        }
    }
    chainLine($target,type){

        let _NUM = 4;

        switch (type){
            case "set":
                for(let i=0; i<_NUM; i++){

                    let _$t = $target.find(".js__chain-line-c").eq(i);

                    switch (i){
                        case 0 :
                            TweenMax.set(_$t,{x:-101+"%"});
                            break;
                        case 1 :
                            TweenMax.set(_$t,{y:-101+"%"});
                            break;
                        case 2 :
                            TweenMax.set(_$t,{x:101+"%"});
                            break;
                        case 3 :
                            TweenMax.set(_$t,{y:101+"%"});
                            break;
                    }

                }
                break;
            case "show":

                // for(let i=0; i<_NUM; i++){
                //
                //     let _$t = $target.find(".js__chain-line-c").eq(i);
                //
                //     switch (i){
                //         case 0 || 2 :
                //             break;
                //         case 1 || 3 :
                //             TweenMax.to(_$t,0.6,{
                //                 y : 0+"%",
                //                 ease: Expo.easeOut,
                //             })
                //             break;
                //     }
                //
                // }

                TweenMax.to($target.find(".js__chain-line-c"),0.6,{
                    x : 0+"%",
                    y : 0+"%",
                    ease: Expo.easeOut,
                })

                break;
            case "out":

                TweenMax.killTweensOf($target.find(".js__chain-line-c"));

                for(let i=0; i<_NUM; i++){

                    let _$t = $target.find(".js__chain-line-c").eq(i);

                    switch (i){
                        case 0 :
                            TweenMax.to(_$t,0.3,{x:-101+"%"});
                            break;
                        case 1 :
                            TweenMax.to(_$t,0.3,{y:-101+"%"});
                            break;
                        case 2 :
                            TweenMax.to(_$t,0.3,{x:101+"%"});
                            break;
                        case 3 :
                            TweenMax.to(_$t,0.3,{y:101+"%"});
                            break;
                    }

                }

                break;
        }
    }

    svg($target,type){
        switch (type){
            case "set":
                TweenLite.set($target.find(".js__svg-write"), {drawSVG: "0%"});
                break;
            case "show":
                TweenMax.staggerTo($target.find(".js__svg-write"), 0.6, {
                    drawSVG: "100%",
                    ease: Expo.easeOut,
                }, .01);
                break;
            case "out":
                TweenMax.staggerTo($target.find(".js__svg-write"), 0.6, {
                    drawSVG: "0%",
                    ease: Expo.easeOut,
                }, .01);
                break;
        }
    }
    btn($target,type,event){
        switch (type){
            case "set":
                let text = new SplitText($target.find(".js__btn-split"), {type:"words,chars"}),
                    chars = text.chars;
                break;
            case "show":

                TweenMax.killChildTweensOf($target.find(".js__btn-split"));
                if(!$target.hasClass("is-current")&&event=="hover") this.btnLine($target,type);
                TweenMax.to($target.find(".js__btn-split:not('.is-none') >* >*"), 0.1, {
                    // scaleX:4,
                    opacity:0,
                    ease: Expo.easeOut,
                    onStart:()=>{
                        if(event=="hover") $target.addClass("is-hover");
                        TweenMax.staggerTo($target.find(".js__btn-split:not('.is-none') >* >*"), 0.3, {
                            // scaleX:1,
                            opacity:1,
                            ease: Expo.easeOut,
                        }, .05);

                    }
                });
                break;
            case "out":
                // TweenMax.killChildTweensOf($target);
                if(!$target.hasClass("is-current")&&event=="hover") this.btnLine($target,type);
                let _$t = event!=="update"?$target.find(".js__btn-split:not('.is-none') >* >*"):$target.find(".js__btn-split >* >*");
                // TweenMax.staggerTo(_$t, 0.3, {
                //     // scaleX:4,
                //     opacity:0,
                //     ease: Power2.easeOut,
                //     onComplete:()=>{
                //         if(event=="update")return;
                //         if(event=="hover") $target.removeClass("is-hover")
                //         TweenMax.to($target.find(".js__btn-split:not('.is-none') >* >*"), 0.3, {
                //             // scaleX:1,
                //             opacity:1,
                //             ease: Expo.easeIn,
                //         });
                //
                //     }
                // });
                if(event=="update"){
                    TweenMax.staggerTo(_$t, 0.3, {
                        // scaleX:4,
                        opacity:0,
                        ease: Power2.easeOut,
                        },0.1
                    );
                }else{
                    if(event=="hover") $target.removeClass("is-hover")
                }
                break;
        }
    }
    btnLine($target,type){

        switch (type){
            case "show":
                TweenMax.fromTo($target.find(".js__btn-line >*"),0.6,{
                    x : -101+"%",
                },{
                    x : 0+"%",
                    ease: Expo.easeOut,
                })
                break;
            case "out":
                TweenMax.to($target.find(".js__btn-line >*"),0.6,{
                    x : 101+"%",
                    ease: Expo.easeOut,
                })
                break;
        }
    }
    splitText($target,type){

        switch (type){
            case "set":
                let text = new SplitText($target, {type:"words,chars"}),
                    chars = text.chars;
                TweenMax.set(chars,{ opacity:0});
                // TweenMax.set(chars,{ opacity:0, x:150});
                break;
            case "show":
                if(!Useragnt.mobile){
                    for(let i=0; i<$target.length; i++){

                        let _delay = util.random(0.0,0.6);

                        TweenMax.to($target.eq(i),0.4,{
                            opacity : 1,
                            delay : _delay,
                            ease: Power2.easeOut,
                        })

                    }
                }else{

                    let _delay = $target.length>10?0.01:0.1;

                    TweenMax.staggerTo($target, 0.6, {
                            opacity : 1,
                            ease: Power2.easeOut,
                        },_delay
                    );

                }


                break;
            case "out":
                TweenMax.killTweensOf($target);
                TweenMax.to($target,0.4,{
                    opacity : 0,
                    ease: Power2.easeOut,
                })
                // for(let i=0; i<$target.length; i++){
                //
                //     let _delay = util.random(0.0,0.6);
                //
                //     TweenMax.to($target.eq(i),0.4,{
                //         opacity : 0,
                //         delay : _delay,
                //         ease: Power2.easeOut,
                //     })
                //
                // }
                break;
        }

    }

    /* 写真の表示用 */
    bgImg($target,type){


        switch (type) {
            case "set":
                TweenMax.set($target, {opacity: 0, scale: 1});
                break;
            case "show":
                TweenMax.to($target, 0.9, {
                    opacity: 1,
                    // z:0,
                    ease: "Power2.easeInOut",
                });

                TweenMax.to($target, 10.0, {
                    scale: 1.2,
                    // z:0,
                    ease: "Power2.easeOut",
                });
                break;
            case "out":
                TweenMax.to($target, 0.4, {
                    opacity: 0,
                    // z:1,
                    scale: 1.0,
                    // z:0,
                    ease: "Power2.easeIn",
                });
                break;
        }

    }

}
